(function () {
  var STORAGE_SUBSCRIBED = 'ci_newsletter_subscribed';
  var STORAGE_DISMISSED = 'ci_newsletter_dismissed';

  function unlockPageScroll() {
    document.body.classList.remove('ci-nl-popup-open');
    document.body.classList.remove('overflow-hidden');
    document.documentElement.classList.remove('ci-nl-popup-open');
  }

  function mountToBody(root) {
    if (!root || root.parentNode === document.body) return;
    document.body.appendChild(root);
  }

  function isSuccessActive(root) {
    var panel = root && root.querySelector('[data-ci-nl-success-panel]');
    return !!(panel && !panel.hidden);
  }

  function showSuccessState(root, modal, tab) {
    var intro = root.querySelector('[data-ci-nl-intro]');
    var formArea = root.querySelector('[data-ci-nl-form-area]');
    var fine = root.querySelector('[data-ci-nl-fine]');
    var successPanel = root.querySelector('[data-ci-nl-success-panel]');
    var body = root.querySelector('[data-ci-nl-body]');
    var modalEl = modal || root.querySelector('[data-ci-nl-modal]');

    if (intro) intro.hidden = true;
    if (formArea) formArea.hidden = true;
    if (fine) fine.hidden = true;
    if (body) body.classList.add('ci-nl-popup__body--success');

    if (successPanel) {
      successPanel.hidden = false;
      successPanel.removeAttribute('hidden');
      successPanel.classList.add('is-visible');
    }

    markSubscribed();
    hideTab(tab);
    openModal(modalEl);

    window.setTimeout(function () {
      var focusTarget =
        successPanel && successPanel.querySelector('[data-ci-nl-success-close]');
      if (focusTarget) focusTarget.focus();
    }, 100);
  }

  function showFormError(root, message) {
    var errorEl = root.querySelector('#CiNewsletterPopup-error');
    if (!errorEl) return;
    errorEl.textContent = message || 'No pudimos registrar tu correo. Intenta de nuevo.';
    errorEl.hidden = false;
    errorEl.removeAttribute('hidden');
  }

  function clearFormError(root) {
    var errorEl = root.querySelector('#CiNewsletterPopup-error');
    if (!errorEl) return;
    errorEl.textContent = '';
    errorEl.hidden = true;
  }

  function setSubmitLoading(form, loading) {
    var btn = form && form.querySelector('[data-ci-nl-submit]');
    if (!btn) return;
    var label = btn.querySelector('[data-ci-nl-submit-label]');
    var loadingLabel = btn.querySelector('[data-ci-nl-submit-loading]');
    btn.disabled = !!loading;
    if (label) label.hidden = !!loading;
    if (loadingLabel) loadingLabel.hidden = !loading;
  }

  function submitNewsletterForm(root, modal, tab) {
    var form = root.querySelector('#CiNewsletterPopupForm');
    if (!form) return;

    clearFormError(root);
    setSubmitLoading(form, true);

    var action = form.getAttribute('action') || '/contact';
    fetch(action, {
      method: 'POST',
      body: new FormData(form),
      credentials: 'same-origin',
      headers: {
        Accept: 'text/html',
      },
    })
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var posted = doc.querySelector('[data-ci-nl-form-success]');
        var errorNode = doc.getElementById('CiNewsletterPopup-error');
        var errorText = errorNode ? errorNode.textContent.replace(/\s+/g, ' ').trim() : '';

        if (posted || (!errorText && html.indexOf('data-ci-nl-form-success') !== -1)) {
          showSuccessState(root, modal, tab);
          return;
        }

        if (errorText) {
          showFormError(root, errorText);
          return;
        }

        showSuccessState(root, modal, tab);
      })
      .catch(function () {
        showFormError(root, 'Hubo un problema de conexión. Intenta de nuevo.');
      })
      .finally(function () {
        setSubmitLoading(form, false);
      });
  }

  function initNewsletterPopup() {
    var root = document.querySelector('[data-ci-newsletter-popup]');
    if (!root || root.dataset.ciNlReady === 'true') return;
    if (root.hasAttribute('hidden')) return;

    root.dataset.ciNlReady = 'true';
    mountToBody(root);
    unlockPageScroll();

    var modal = root.querySelector('[data-ci-nl-modal]');
    var tab = root.querySelector('[data-ci-nl-tab]');
    var delayMs = (parseInt(root.dataset.delay, 10) || 10) * 1000;
    var timer = null;

    if (!modal) return;

    if (isSubscribed()) {
      hideAll(root, modal, tab);
      return;
    }

    bindEvents(root, modal, tab);

    if (root.querySelector('[data-ci-nl-form-success]')) {
      showSuccessState(root, modal, tab);
      return;
    }

    if (wasDismissed()) {
      showTab(tab);
    } else {
      timer = window.setTimeout(function () {
        if (!isSubscribed() && !wasDismissed() && !isSuccessActive(root)) {
          openModal(modal);
        }
      }, delayMs);
    }

    root._ciNlTimer = timer;
  }

  function isSubscribed() {
    try {
      return localStorage.getItem(STORAGE_SUBSCRIBED) === '1';
    } catch (e) {
      return false;
    }
  }

  function wasDismissed() {
    try {
      return localStorage.getItem(STORAGE_DISMISSED) === '1';
    } catch (e) {
      return false;
    }
  }

  function markSubscribed() {
    try {
      localStorage.setItem(STORAGE_SUBSCRIBED, '1');
      localStorage.removeItem(STORAGE_DISMISSED);
    } catch (e) {
      /* ignore */
    }
  }

  function markDismissed() {
    try {
      localStorage.setItem(STORAGE_DISMISSED, '1');
    } catch (e) {
      /* ignore */
    }
  }

  function lockPageScroll() {
    document.body.classList.add('ci-nl-popup-open');
    document.documentElement.classList.add('ci-nl-popup-open');
  }

  function openModal(modal) {
    if (!modal) return;
    modal.hidden = false;
    modal.removeAttribute('hidden');
    modal.classList.add('is-visible');
    lockPageScroll();

    window.requestAnimationFrame(function () {
      var panel = modal.querySelector('.ci-nl-popup__panel');
      if (!panel || panel.getBoundingClientRect().height < 8) {
        unlockPageScroll();
        modal.hidden = true;
        return;
      }
    });
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.classList.remove('is-visible');
    modal.hidden = true;
    unlockPageScroll();
  }

  function showTab(tab) {
    if (!tab) return;
    tab.hidden = false;
    tab.removeAttribute('hidden');
    tab.classList.add('is-visible');
  }

  function hideTab(tab) {
    if (!tab) return;
    tab.hidden = true;
    tab.classList.remove('is-visible');
  }

  function hideAll(root, modal, tab) {
    if (root && root._ciNlTimer) {
      clearTimeout(root._ciNlTimer);
    }
    closeModal(modal);
    hideTab(tab);
    unlockPageScroll();
    if (root) root.hidden = true;
  }

  function handleClose(root, modal, tab) {
    if (isSuccessActive(root)) {
      markSubscribed();
      hideAll(root, modal, tab);
      return;
    }
    markDismissed();
    closeModal(modal);
    showTab(tab);
  }

  function bindEvents(root, modal, tab) {
    root.querySelectorAll('[data-ci-nl-close]').forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        handleClose(root, modal, tab);
      });
    });

    var successClose = root.querySelector('[data-ci-nl-success-close]');
    if (successClose) {
      successClose.addEventListener('click', function (event) {
        event.preventDefault();
        markSubscribed();
        hideAll(root, modal, tab);
      });
    }

    if (tab) {
      tab.addEventListener('click', function () {
        hideTab(tab);
        openModal(modal);
      });
    }

    var form = root.querySelector('#CiNewsletterPopupForm');
    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        submitNewsletterForm(root, modal, tab);
      });
    }

    if (!root.dataset.ciNlEscapeBound) {
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && modal && !modal.hidden) {
          handleClose(root, modal, tab);
        }
      });
      root.dataset.ciNlEscapeBound = 'true';
    }
  }

  unlockPageScroll();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNewsletterPopup);
  } else {
    initNewsletterPopup();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('[data-ci-newsletter-popup]')) {
      var existing = document.querySelector('[data-ci-newsletter-popup]');
      if (existing) existing.dataset.ciNlReady = 'false';
      initNewsletterPopup();
    }
  });

  window.addEventListener('pageshow', unlockPageScroll);
})();
